<template>
  <div class="product-edit-address">
    <el-dialog width="550px" v-if="visible" :visible.sync="visible">
      <div class="header">
        <div class="title">{{ params.id ? "修改" : "新增" }}收货地址</div>
        <img class="close" src="@/assets/icon/close.png" alt="" />
      </div>
      <div class="content">
        <div class="item">
          <div class="label">收货人</div>
          <div class="value">
            <el-input
              v-model="params.name"
              placeholder="请输入收货人"
            ></el-input>
          </div>
        </div>
        <div class="item">
          <div class="label">手机号码</div>
          <div class="value">
            <el-input
              v-model="params.phone"
              placeholder="请输入手机号码"
            ></el-input>
          </div>
        </div>
        <div class="item">
          <div class="label">所在地区</div>
          <div class="value">
            <el-cascader
              placeholder="请选择所在地区"
              v-model="current_city"
              :options="city_list"
              :props="{
                value: 'name',
                label: 'name',
              }"
              @change="handleChange"
            ></el-cascader>
          </div>
        </div>
        <div class="item">
          <div class="label">详细地址</div>
          <div class="value">
            <el-input
              v-model="params.detail"
              placeholder="请输入详细地址"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="btn-box">
        <div class="btn confirm" @click="handleConfirm">
          {{ params.id ? "保存信息" : "新增地址" }}
        </div>
        <div
          class="btn cancel"
          :style="{
            opacity: params.id ? '1' : '0.5',
            cursor: params.id ? 'pointer' : 'no-drop',
          }"
          @click="handleDelete"
        >
          删除
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { AreaService, AddressService } from "@/common/service";
export default {
  name: "ProductEditAddress",
  data() {
    return {
      visible: false,
      params: {
        name: "", // 联系人
        phone: "", // 联系电话
        pro_name: "", // 省名
        city_name: "", // 市名
        county_name: "", // 县区名
        detail: "", // 详细地址
      },
      current_city: [],
      city_list: [],
    };
  },
  created() {
    this.getAreaTree();
  },
  methods: {
    // 获取地址库
    getAreaTree() {
      AreaService.getAreaTree().then(({ data }) => {
        this.city_list = data.list;
      });
    },
    // 地址选择
    handleChange(val) {
      let key = ["pro_name", "city_name", "county_name"];
      key.forEach((item, index) => {
        this.params[item] = val[index];
      });
    },
    // 校验
    handleCheck() {
      let checkForm = {
        name: "请输入联系人",
        phone: "请输入联系电话",
        pro_name: "请选择所在地区",
        city_name: "请选择市名",
        county_name: "请选择县区名",
        detail: "请输入详细地址",
      };
      for (let key in checkForm) {
        if (!this.params[key]) return this.$message.error(checkForm[key]);
      }
      return false;
    },
    // 确认
    handleConfirm() {
      if (this.handleCheck()) return;
      AddressService.setDeliveryAddress(this.params).then(() => {
        this.$message.success(this.params.id ? "编辑成功" : "新增成功");
        this.close();
      });
    },
    // 删除
    handleDelete() {
      if (!this.params.id) return;
      AddressService.delDeliveryAddress({ id: this.params.id }).then(
        ({ msg }) => {
          this.$message.success(msg);
          this.close();
        }
      );
    },
    // 打开
    open(val) {
      if (!val) return (this.visible = true);
      let key = ["pro_name", "city_name", "county_name"],
        arr = [];
      key.forEach((item) => {
        arr.push(val[item]);
      });
      this.current_city = arr;
      this.params = val;
      this.visible = true;
    },
    // 关闭
    close() {
      this.visible = false;
      this.$emit("handleClose");
    },
  },
};
</script>

<style lang="scss" scoped>
.product-edit-address {
  /deep/ .el-dialog {
    border-radius: 10px;
    .el-dialog__header {
      display: none;
    }
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      font-size: 20px;
      font-weight: 600;
      color: #222222;
    }
    .close {
      width: 14px;
      height: 14px;
    }
  }
  .content {
    .item {
      height: 44px;
      margin-top: 20px;
      display: flex;
      align-items: center;
      .label {
        height: 44px;
        width: 90px;
        font-size: 14px;
        color: #222222;
        line-height: 44px;
        text-align: right;
        &::before {
          content: "*";
          color: #ff0000;
        }
      }
      .value {
        margin-left: 20px;
        width: calc(100% - 130px);
        /deep/ .el-cascader {
          width: 100%;
        }
      }
    }
  }
  .btn-box {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    .btn {
      width: 144px;
      height: 56px;
      border-radius: 6px;
      box-sizing: border-box;
      font-size: 18px;
      font-weight: 500;
      text-align: center;
      line-height: 56px;
      cursor: pointer;
    }
    .confirm {
      background: #0054f7;
      color: #ffffff;
    }
    .cancel {
      border: 1px solid #0054f7;
      color: #0054f7;
      margin-left: 20px;
    }
  }
}
</style>
